<div class="img_renderer">
  <div class="img_content">
    <img [style.max-width.px]="142" [style.max-height.px]="142" src="{{data.ImagePath}}" id="img-{{index}}">
  </div>
  <label>{{data.ImageName}}</label>
  <label>{{data.ImageFileName}}</label>
  <label>優先度：{{data.Priority}}</label>
  <label>使用開始：{{data.StartOrderCode}}</label>
  <app-checkbox-label label="画像出力" #chkId [subid]="'chkId'"
    [(ngModel)]="data.Selected" [tabindex]="-1"></app-checkbox-label>
</div>
